module.exports = __webpack_public_path__ + "e79f2190498c36b1fa3cf183443fe51e.jpg";